var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.375,
    cy: 14,
    r: 14,
    fill: "#DCEFE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5602 22.7033H10.5122L10.3342 16.1093V16.0973L10.2842 13.8693C10.2682 13.1333 10.4402 12.4013 10.7842 11.7513C11.1242 11.1073 11.6242 10.5573 12.2302 10.1593C12.2762 10.1293 12.3002 10.0833 12.3002 10.0253L12.2182 4.86328H15.8642L15.7822 10.0253C15.7822 10.0813 15.8062 10.1273 15.8522 10.1593C16.4582 10.5593 16.9582 11.1093 17.2982 11.7513C17.6422 12.4013 17.8142 13.1333 17.7982 13.8693L17.5602 22.7033ZM10.9002 22.3053H17.1742L17.4022 13.8593C17.4182 13.1933 17.2602 12.5273 16.9482 11.9373C16.6402 11.3533 16.1862 10.8533 15.6342 10.4913C15.4722 10.3853 15.3822 10.2133 15.3842 10.0193L15.4602 5.26328H12.6222L12.6982 10.0193C12.7022 10.2093 12.6082 10.3873 12.4482 10.4913C11.8982 10.8533 11.4442 11.3533 11.1342 11.9373C10.8222 12.5273 10.6662 13.1913 10.6802 13.8593L10.7302 16.0973V16.1093L10.8962 22.3053H10.9002Z",
    fill: "#8E1A20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.964 13.8492L16.748 21.8672H11.328L11.172 16.1112C11.172 16.1112 11.172 16.0932 11.172 16.0852L11.122 13.8492C11.108 13.2552 11.248 12.6652 11.526 12.1412C11.8 11.6232 12.204 11.1772 12.692 10.8552C12.978 10.6672 13.144 10.3512 13.138 10.0112L13.068 5.69922H15.016L14.946 10.0112C14.94 10.3532 15.108 10.6692 15.392 10.8552C15.882 11.1772 16.284 11.6212 16.558 12.1412C16.836 12.6652 16.974 13.2572 16.962 13.8492H16.964Z",
    fill: "#8E1A20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRed);
export default __webpack_public_path__ + "static/media/Red.bfa631ae963fe81c50983b322cd0dc8b.svg";
export { ForwardRef as ReactComponent };